module.exports = __webpack_public_path__ + "static/assets/83c99591870ddbf7d1d1ba89029b21ec.png";